module.exports = __webpack_public_path__ + "static/media/logo.471d78e8.svg";